// src/components/TrialExpiredOverlay.js
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import UpgradeModal from './UpgradeModal';
import './TrialExpiredOverlay.css';

const TrialExpiredOverlay = ({ section = 'content' }) => {
  const { currentUser } = useAuth();
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  // Check if overlay should be shown
  const shouldShowOverlay = () => {
    if (!currentUser) return false;

    // Show overlay if:
    // 1. User has no active subscription (plan is 'none')
    // 2. Trial has expired (subscriptionStatus is 'expired' or trial end date is in the past)
    const hasNoSubscription = currentUser.plan === 'none';
    const isExpired = currentUser.subscriptionStatus === 'expired';

    // Check if trial end date has passed
    let trialExpired = false;
    if (currentUser.trialEndAt) {
      const trialEndDate = new Date(currentUser.trialEndAt);
      const now = new Date();
      trialExpired = now > trialEndDate;
    }

    return hasNoSubscription && (isExpired || trialExpired);
  };

  const handleSubscribeClick = () => {
    setShowUpgradeModal(true);
  };

  if (!shouldShowOverlay()) {
    return null;
  }

  return (
    <>
      <div className={`trial-expired-overlay ${section}`}>
        <div className="trial-expired-overlay-content">
          <div className="trial-expired-icon">🔒</div>
          <h3>Your trial period has expired</h3>
          <p>Subscribe to the Pro Plan to continue accessing all features</p>
          <button
            onClick={handleSubscribeClick}
            className="trial-expired-btn"
          >
            View Subscription Plans
          </button>
        </div>
      </div>

      <UpgradeModal
        isOpen={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
      />
    </>
  );
};

export default TrialExpiredOverlay;
